module.exports = "<ea-activities-page></ea-activities-page>"


//////////////////
// WEBPACK FOOTER
// ./src/ui/modules/eaAdministration/eaActivities/eaActivitiesPage/eaActivitiesPageModule.html
// module id = 950
// module chunks = 12